import { Link } from "react-router-dom";
import { Footprints, Flag, MapPin, Users, TrendingUp, ArrowDown, Leaf, Droplets, TreePine, Recycle, HandHeart } from "lucide-react";
import PageHero from "@/components/PageHero";

const MODEL = [
  { icon: Footprints, title: "RUNNERS", desc: "Participants travelling from within and outside the destination.", color: "text-brand-cyan" },
  { icon: Flag, title: "EVENT", desc: "A professionally organised sporting experience.", color: "text-brand-olive" },
  { icon: MapPin, title: "DESTINATION", desc: "Nature, heritage, culture and local attractions.", color: "text-brand-cyan" },
  { icon: Users, title: "COMMUNITY", desc: "Local people, businesses, institutions and volunteers.", color: "text-brand-olive" },
  { icon: TrendingUp, title: "IMPACT", desc: "Visibility, tourism, livelihood opportunities and fitness culture.", color: "text-brand-cyan" },
];

const SUSTAIN = [
  { icon: Recycle, t: "Say No to Plastic" }, { icon: Leaf, t: "Clean & Green Destinations" },
  { icon: TreePine, t: "Plant a Tree" }, { icon: Droplets, t: "Save Water" },
  { icon: TreePine, t: "Protect Forests" }, { icon: HandHeart, t: "Wildlife Conservation" },
  { icon: MapPin, t: "Responsible Tourism" }, { icon: Users, t: "Community Participation" },
];

const ALIGNMENT = [
  { t: "DEKHO APNA DESH", d: "Promoting lesser-known destinations and encouraging domestic exploration." },
  { t: "SWADESH DARSHAN", d: "Supporting the broader destination-development context through sports tourism." },
  { t: "FIT INDIA", d: "Using running and sporting participation to encourage fitness." },
  { t: "SOCIAL INITIATIVES", d: "Supporting appropriate social and community-oriented campaigns through events." },
];

export default function SportsTourism() {
  return (
    <div data-testid="sports-tourism-page">
      <PageHero eyebrow="SPORTS TOURISM" title="Bringing People, Places & Sport Together."
        subtitle="SPORTIVE believes sporting events can become powerful platforms for destination development. A professionally organised marathon brings runners, families, volunteers, officials, sponsors and travellers together — creating an ecosystem that extends far beyond race day."
        image="https://images.unsplash.com/photo-1596727362302-b8d891c42ab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxtYXJhdGhvbiUyMHJ1bm5lcnMlMjByYWNlJTIwc3RhcnR8ZW58MHx8fHwxNzg5MDY4MTkwfDA&ixlib=rb-4.1.0&q=85" />

      <section className="mx-auto max-w-4xl px-4 py-20 sm:px-6">
        <p className="eyebrow text-center">OUR SPORTS TOURISM MODEL</p>
        <div className="mt-12 space-y-0">
          {MODEL.map((m, i) => (
            <div key={m.title}>
              <div className="card-k mx-auto flex max-w-xl items-center gap-5 p-6 transition-colors hover:border-brand-cyan/40">
                <span className={`rounded-xl bg-brand-ink p-3 ${m.color}`}><m.icon size={22} /></span>
                <div>
                  <h3 className="font-display text-xl font-bold tracking-wide text-white">{m.title}</h3>
                  <p className="mt-1 text-sm text-slate-400">{m.desc}</p>
                </div>
                <span className="ml-auto font-mono text-xs text-slate-600">{String(i + 1).padStart(2, "0")}</span>
              </div>
              {i < MODEL.length - 1 && <div className="flex justify-center py-2"><ArrowDown size={18} className="text-brand-olive" /></div>}
            </div>
          ))}
        </div>
      </section>

      <section className="border-y border-brand-line bg-brand-surface/40">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6">
          <p className="eyebrow">RUN RESPONSIBLY</p>
          <h2 className="mt-3 max-w-2xl font-display text-4xl font-bold uppercase tracking-tight text-white">Every Destination Deserves to Be Protected.</h2>
          <p className="mt-4 max-w-2xl text-slate-400">SPORTIVE promotes responsible participation and respect for the destinations where our events are conducted.</p>
          <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
            {SUSTAIN.map((s) => (
              <div key={s.t} className="card-k flex flex-col items-center gap-3 p-6 text-center transition-colors hover:border-brand-olive/50">
                <s.icon size={22} className="text-brand-olive" />
                <p className="text-xs font-semibold tracking-wide text-slate-200">{s.t}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6">
        <p className="eyebrow">STRATEGIC ALIGNMENT</p>
        <h2 className="mt-3 max-w-2xl font-display text-4xl font-bold uppercase tracking-tight text-white">Aligned With India's Aspirations</h2>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {ALIGNMENT.map((a) => (
            <div key={a.t} className="card-k p-6">
              <h3 className="font-display text-lg font-bold tracking-wide text-brand-cyan">{a.t}</h3>
              <p className="mt-2 text-xs leading-relaxed text-slate-400">{a.d}</p>
            </div>
          ))}
        </div>
        <p className="mt-6 text-xs text-slate-600">SPORTIVE's events are thematically aligned with these national initiatives; formal partnerships are announced separately.</p>
        <Link to="/partners" data-testid="st-partner-cta" className="btn-kinetic btn-primary-k mt-10">PARTNER WITH SPORTIVE</Link>
      </section>
    </div>
  );
}
